import React, { useState, useEffect } from 'react';

import { signin, signup } from '../../database/actions/auth';



import '../styles/auth.css'
import Forml from './Forml';

const Auth = () => {
	const [isSignUp, setIsSignUp] = useState(false);

	useEffect(() => {

	})

	return (
		<>
			<div className="auth">
				<div className="auth-container">
					<div className="login">
						<Forml signin={signin} signup={signup} setIsSignUp={setIsSignUp} isSignUp={isSignUp} />
					</div>
				</div>
			</div>
		</>
	)
}

export default Auth